import { Component, inject } from '@angular/core';
import { HttpService } from '@core/services';

@Component({
  selector: 'app-cp-loading',
  template: ``,
  styles: ``,
})
export class CpLoadingComponent {
  readonly httpService = inject(HttpService);
}
